import { ApolloLink } from '@apollo/client';
import { regionSubdivisionVar } from '../reaction';


//

const initialAddress = {
    address: { type: 'session_address', country_subdivision: 'RU-MOS' },
};

const interceptCountrySubdivision = ({ data }) => {
    const { data: { deliveryAddress, shipping } } = data;

    if (deliveryAddress || shipping) {
        const { address } = deliveryAddress || shipping || initialAddress;
        if (address?.type === 'session_address') {
            const current = regionSubdivisionVar();
            const next = address?.country_subdivision?.replace(/-/, '_');
            if (next !== current) {
                // console.log(`Update ${current} to ${next}`);
                regionSubdivisionVar(next);
            }
        }
    }
};

function handleInterceptUserFields(data, event) {
    try {
        interceptCountrySubdivision({ data });
        if (event.includes('intercept:user:phone')) {
            const { data: { user } } = data;
            const cachedPhone = sessionStorage.getItem('phone');

            const userPhone = user?.phone || cachedPhone || '';

            if (userPhone) {
                sessionStorage.setItem('phone', userPhone);
            }
        }

        return data;
    } catch (e) {
        console.error(e);
        return data;
    }
}

function IntercepUser(operation, forward) {
    const {
        event = [],
        // step
    } = operation.getContext();
    // const { operationName } = operation;

    // console.log(operationName, step, event);
    return forward(operation).map((data) => handleInterceptUserFields(data, event));
}

/**
 * @description Перехватывает телефон пользователя из запроса и ставит его в sessionStorage
 */
export const userInterceptors = new ApolloLink(IntercepUser);
